module.exports = __webpack_public_path__ + "static/idlogo-050b24f4ad817aa2a0d44b5cc3ac4770.png";